module.exports = __webpack_public_path__ + "static/sec8-bg-6378d5774bd38e081601ba9bab4821a4.jpg";